module.exports = __webpack_public_path__ + "static/media/19ESCAP29.da0f7f45.jpg";